import mergeWith from 'lodash/mergeWith';
import isArray from 'lodash/isArray';

const initialState = {
  users: {},
  awards: {},
  info: {},
  categories: {},
  work_photos: {},
  works: {},
  instagram: {}
};

export default function entities(state = initialState, action) {
  if (action.payload && action.payload.entities) {
    return mergeWith(
      {},
      state,
      action.payload.entities,
      (objValue, srcValue) => {
        if (isArray(srcValue)) {
          return srcValue;
        }

        return undefined;
      }
    );
  }

  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/entities.js